<template>
  <!-- 建立这个文件的目的就是为了菜单由后端来的时候可以跳转到第一个有权限的路由 -->
  <div></div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data() {
      return {

      }
    },
    created() {
      this.$store.dispatch('common/promise/getPermissions')
    },
    computed: {
      ...mapState('common/promise', ['trueRoutes'])
    },
    watch: {
      trueRoutes: function() {
        this.jump()
      }
    },
    methods: {
      jump() {
        if (this.trueRoutes.length) {
          console.log(this.trueRoutes)
          this.$router.replace({
            name: this.trueRoutes[0].children[0].name
          })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Index/index.vue